const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '热门连载每日同步更新，追更不等待，最新章节第一时间送达，韩漫日漫国漫全覆盖。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '流畅的下拉滚动阅读体验，无需翻页按钮，沉浸式浏览漫画，阅读节奏由你掌控。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '追漫提醒',
    desc: '订阅喜欢的漫画，更新第一时间推送提醒，不再错过任何一话精彩内容。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '全免费全集',
    desc: '全部漫画免费阅读，完结作品全集收录，从第一话到大结局一气呵成畅快阅读。',
  },
  {
    icon: 'ri-global-line',
    title: '三漫齐聚',
    desc: '韩漫、日漫、国漫三大品类一站式聚合，热门冷门全都有，发现你的下一部心头好。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择番茄漫画
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            专注漫画追更体验，五大核心优势让追漫更简单
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}